import { MessageCircle, FileDown, X } from "lucide-react";
import api from "@/api";
import ModalShell from "@/components/shared/ModalShell";
import { toast } from "sonner";

export const EscalationFollowupModal = ({ result, patientId, onClose }) => {
  if (!result) return null;
  const links = (result.externalNotifications || []).filter((n) => n.whatsappLink);
  const missing = (result.externalNotifications || []).filter((n) => !n.whatsappLink);

  const openWhatsApp = (item) => {
    if (patientId) {
      api.post(`/patients/${patientId}/professional-actions`, {
        uiSurface: "escalation_followup",
        actionType: "WHATSAPP_ESCALATION_OPENED",
        targetModule: "doctor_escalation",
        channel: "WHATSAPP",
        outcome: "EXTERNAL_LINK_OPENED",
        targetUserId: item.doctorId,
      }).catch(() => {});
    }
    window.open(item.whatsappLink, "_blank", "noopener");
  };

  const downloadPdf = async () => {
    try {
      const res = await api.get(result.printablePdfUrl.replace(/^\/api/, ""), { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = "hana-escalade.pdf";
      a.click();
      URL.revokeObjectURL(url);
    } catch {
      toast.error("Impossible de générer la fiche PDF");
    }
  };

  return (
    <ModalShell overlayTestId="escalation-followup-modal" overlayClass="bg-black/40" containerClass="bg-white rounded-2xl shadow-xl">
      <div className="p-6 space-y-4">
        <div className="flex items-start justify-between">
          <div>
            <h3 className="font-bold text-slate-800 text-lg">Alerte escaladée au médecin</h3>
            <p className="text-sm text-slate-500 mt-1">Le médecin est notifié dans Hana. Vous pouvez aussi le prévenir depuis votre WhatsApp.</p>
          </div>
          <button onClick={onClose} className="p-2 hover:bg-slate-100 rounded-lg" data-testid="escalation-followup-close"><X className="w-4 h-4" /></button>
        </div>
        <div className="space-y-2">
          {links.map((item) => (
            <button key={item.doctorId} onClick={() => openWhatsApp(item)} data-testid={`escalation-whatsapp-${item.doctorId}`}
              className="w-full flex items-center gap-3 border border-emerald-200 bg-emerald-50 text-emerald-800 rounded-xl px-4 py-3 text-sm font-medium hover:bg-emerald-100 transition-colors">
              <MessageCircle className="w-4 h-4" /> Ouvrir WhatsApp — Dr {item.doctorName}
            </button>
          ))}
          {missing.map((item) => (
            <p key={item.doctorId} className="text-xs text-slate-500" data-testid={`escalation-nophone-${item.doctorId}`}>Dr {item.doctorName} : aucun numéro WhatsApp renseigné.</p>
          ))}
          {links.length === 0 && missing.length === 0 && <p className="text-xs text-slate-500" data-testid="escalation-no-doctor">Aucun médecin référent avec numéro renseigné.</p>}
        </div>
        <div className="flex gap-2 pt-2">
          <button onClick={downloadPdf} data-testid="escalation-pdf-btn" className="flex-1 flex items-center justify-center gap-2 border border-slate-200 rounded-xl px-4 py-2.5 text-sm font-medium text-slate-700 hover:bg-slate-50">
            <FileDown className="w-4 h-4" /> Fiche PDF
          </button>
          <button onClick={onClose} data-testid="escalation-followup-done" className="flex-1 bg-emerald-600 text-white rounded-xl px-4 py-2.5 text-sm font-semibold hover:bg-emerald-700">Terminé</button>
        </div>
      </div>
    </ModalShell>
  );
};

export default EscalationFollowupModal;
